import React from 'react'
import Link from 'gatsby-link'
import Img from 'gatsby-image'
import _ from 'underscore'

import styles from './sponsor-preview.module.css'

export default ({ sponsor }) => (
  <div className={styles.cardItem}>
    <div className={`${styles.cardImage}`}>
      { sponsor.image !== null ? (
          <Img alt={sponsor.title} sizes={sponsor.image.sizes} />
          ) : (
            <span>&nbsp;</span>
          )
      }
    </div>
    <div className={styles.cardInfo}>
      <h3 className={styles.cardTitle}>{sponsor.name}</h3>
      <div className={styles.cardExcerpt}>{sponsor.shortBio.shortBio}</div>
    </div>
  </div>
)

// <Link to={`/sponsor/${sponsor.slug}`}>
  // </Link>


// WEBPACK FOOTER //
// ./src/components/sponsor-preview.js